<template>
	<div class="loading df wao hao" v-if="has">
		<div class="box">
			<div class="icon"></div>
			<div class="cap">{{option.title}}</div>
			<div class="txt" v-if="option.message">{{option.message}}</div>
			<div class="btn" v-if="option.btn" @click="tapBtn">{{option.btn}}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'loading',
	data () {
		return {
			has: false,
			option: {
				isConfirm: 0,
				title: '',
				message: '',
				btn: null,
				btnCall: null,
			},
		}
	},
	methods: {
		tapBtn(type){
			this.has = false
			this.option.btnCall && this.option.btnCall()
		},
	},
}
</script>

<style lang="less" scoped>
	.loading{
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		z-index: 9995;
		background: rgba(0, 0, 0, 0.4);

		.box{
			background: #FFFFFF;
			box-shadow: 0px 9px 28px 8px rgba(0,0,0,0.05), 0px 6px 16px 0px rgba(0,0,0,0.08), 0px 3px 6px -4px rgba(0,0,0,0.12);
			border-radius: 4px 4px 4px 4px;
			position: relative;
			max-width: 368px;
			min-width: 280px;
			padding: 40px 24px;
			.icon{
				width: 48px;
				height: 48px;
				background: url(../../assets/img/loading.png) center center / 100% auto no-repeat;
				margin: 0 auto;
				animation: loadingIcon 2s 0s linear infinite;
			}
			@keyframes loadingIcon {
				0% {
					transform: rotate(0);
				}
				100% {
					transform: rotate(360deg);
				}
			}
			.cap{
				margin-top: 16px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #1D2129;
				line-height: 22px;
				text-align: center;
			}
			.txt{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #86909C;
				line-height: 22px;
				text-align: center;
			}
			.btn{
				width: 140px;
				background: #009B73;
				border-radius: 2px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 32px;
				text-align: center;
				margin: 16px auto 0 auto;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue